/**
 * Firebase Configuration
 *
 * This file exports Firebase configuration from environment variables.
 * The actual configuration is loaded from .env files based on the environment.
 *
 * @deprecated Import from src/config/index.js instead
 */

import { firebaseConfig } from '../config/index.js';

// Export for backward compatibility
export const config = firebaseConfig;
